const DEFAULT_OPTIONS: RequestInit = {
	mode: "cors",
	headers: {
		"Content-Type": "application/json",
		Accept: "application/json",
	},
}

export class ApiClient {
	apiUrl: string
	options: RequestInit
	constructor(apiUrl: string, options?: Partial<RequestInit>) {
		this.apiUrl = apiUrl
		this.options = { ...DEFAULT_OPTIONS, ...options }
	}

	async get(route: string, options?: RequestInit) {
		const res = await fetch(`${this.apiUrl}${route}`, {
			...this.options,
			...options,
			method: "GET",
		})
		return res.json()
	}

	async delete(route: string, options?: RequestInit) {
		const res = await fetch(`${this.apiUrl}${route}`, {
			...this.options,
			...options,
			method: "DELETE",
		})
		return res.json()
	}

	async put<T extends { [index: string]: any }>(route: string, body?: T, options?: RequestInit) {
		const requestOptions: RequestInit = {
			...this.options,
			...options,
			method: "PUT",
		}

		if (body !== undefined) {
			requestOptions.body = JSON.stringify(body)
		}

		const res = await fetch(`${this.apiUrl}${route}`, requestOptions)
		return res.json()
	}

	async patch<T extends { [index: string]: any }>(route: string, body?: T, options?: RequestInit) {
		const requestOptions: RequestInit = {
			...this.options,
			...options,
			method: "PATCH",
		}

		if (body !== undefined) {
			requestOptions.body = JSON.stringify(body)
		}

		const res = await fetch(`${this.apiUrl}${route}`, requestOptions)
		return res.json()
	}

	async post<T extends { [index: string]: any }>(route: string, body?: T, options?: RequestInit) {
		const requestOptions: RequestInit = {
			...this.options,
			...options,
			method: "POST",
		}

		if (body !== undefined) {
			requestOptions.body = JSON.stringify(body)
		}

		const res = await fetch(`${this.apiUrl}${route}`, requestOptions)
		if (!res.ok) {
			const errResponse = await res.json()
			throw new Error(
				errResponse.message || `Request failed with status ${res.status} ${res.statusText}`,
			)
		}
		return res.json()
	}

	async postFormData(route: string, formData: FormData, options?: RequestInit) {
		const requestOptions: RequestInit = {
			...this.options,
			...options,
			method: "POST",
			body: formData,
		}

		// Remove Content-Type header to let browser set multipart/form-data boundary
		const headers = new Headers(requestOptions.headers as HeadersInit)
		headers.delete("Content-Type")
		requestOptions.headers = headers

		const res = await fetch(`${this.apiUrl}${route}`, requestOptions)
		return res.json()
	}

	async putFormData(route: string, formData: FormData) {
		const requestOptions: RequestInit = {
			...this.options,
			method: "PUT",
			body: formData,
		}

		// Remove Content-Type header to let browser set multipart/form-data boundary
		const headers = new Headers(requestOptions.headers as HeadersInit)
		headers.delete("Content-Type")
		requestOptions.headers = headers

		const res = await fetch(`${this.apiUrl}${route}`, requestOptions)
		return res.json()
	}
}
